import { getCached, getFromCache } from "./client";

const API_BASE = process.env.REACT_APP_API_URL;

export async function getHome(forceRefresh = false) {
    return await getCached(`${API_BASE}getHome.php`, { datas: [], album: [] }, forceRefresh);
}
export function getHomeCache() {
    return getFromCache(`${API_BASE}getHome.php`);
}

export async function getPostural(forceRefresh = false) {
    return await getCached(`${API_BASE}getPostural.php`, { datas: [], album: [] }, forceRefresh);
}
export function getPosturalCache() {
    return getFromCache(`${API_BASE}getPostural.php`);
}

export async function getTrainer(forceRefresh = false) {
    return await getCached(`${API_BASE}getTrainer.php`, { datas: [], album: [] }, forceRefresh);
}
export function getTrainerCache() {
    return getFromCache(`${API_BASE}getTrainer.php`);
}

export async function getManagement(forceRefresh = false) {
    return await getCached(`${API_BASE}getManagement.php`, { datas: [], album: [] }, forceRefresh);
}
export function getManagementCache() {
    return getFromCache(`${API_BASE}getManagement.php`);
}

export async function getCertification(forceRefresh = false) {
    return await getCached(`${API_BASE}getCertification.php`, { datas: [], album: [] }, forceRefresh);
}
export function getCertificationCache() {
    return getFromCache(`${API_BASE}getCertification.php`);
}

export async function getTeam(forceRefresh = false) {
    return await getCached(`${API_BASE}getTeam.php`, { datas: [], album: [] }, forceRefresh);
}
export function getTeamCache() {
    return getFromCache(`${API_BASE}getTeam.php`);
}

export async function getContact(forceRefresh = false) {
    return await getCached(`${API_BASE}getContact.php`, [], forceRefresh);
}
export function getContactCache() {
    return getFromCache(`${API_BASE}getContact.php`);
}

export async function getFooter(forceRefresh = false) {
    return await getCached(`${API_BASE}getFooter.php`, [], forceRefresh);
}
export function getFooterCache() {
    return getFromCache(`${API_BASE}getFooter.php`);
}

export async function getGallery(forceRefresh = false) {
    return await getCached(`${API_BASE}getGallery.php`, { studio: [], gymManagement: [], certification: [] }, forceRefresh);
}
export function getGalleryCache() {
    return getFromCache(`${API_BASE}getGallery.php`);
}

export async function getNavigation(forceRefresh = false) {
    return await getCached(`${API_BASE}getNavigation.php`, [], forceRefresh);
}
export function getNavigationCache() {
    return getFromCache(`${API_BASE}getNavigation.php`);
}
